
import React from 'react'
import {Component} from 'react';

import Zitat from './Zitat'


class Zitate extends Component {

    render() {
        const {zitate, tabs} = this.props;

        const predicate = z=>z.metapher.text;
        //const predicate = z=>(Math.round(z.year/100)*100);

        return (
            <div className={"zitate-container"}>
                <div className={"zitate"}>
                    {this.renderFullList(zitate, tabs)}
                </div>
            </div>
                    //{this.renderTree(zitate, predicate)}
        );
    }

    renderFullList(zitate, tabs) {
        return zitate.map((zitat, i) => (
            <Zitat {...zitat} key={i} tabs={tabs}
                onShowZitat={this.props.onShowZitat}
            />
        ));
    }

    renderTree(zitate, predicate) {
        let by_key = {};
        for (let i=0; i<zitate.length; ++i) {
            const z = zitate[i];
            const key = predicate(z);
            if (!by_key[key])
                by_key[key] = [z];
            else
                by_key[key].push(z);
        }
        return (
            <ul>
                {Object.values(by_key).map((zitate, i) => (
                    <li key={i}>
                        <b dangerouslySetInnerHTML={{__html: predicate(zitate[0])}}/>
                        <ul>
                            {zitate.map((zitat, i) => (
                                 <li>{zitat.year}</li>
                            ))}
                        </ul>
                    </li>
                ))}
            </ul>
        );
    }
}

export default Zitate;


// WEBPACK FOOTER //
// ./cms_plugins/zitat_display/js/components/Zitate.js